<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.5935 37.6598L17.3206 33.9054C17.6254 33.2429 17.1414 32.4875 16.4122 32.4875H13.8943C13.7466 32.4875 13.6077 32.4115 13.5295 32.2858C13.4485 32.1602 13.4398 32.0024 13.5006 31.865L16.1666 26.0703"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M6.44141 43.7056L6.98851 37.4521C6.98851 37.4521 6.98851 37.4287 6.9914 37.4199L10.1032 18.4841C10.2567 17.5344 11.018 16.8418 11.9067 16.8418H20.6314C21.523 16.8418 22.2814 17.5314 22.4348 18.4841L25.5466 37.4199"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M13.9246 15.217C13.1603 12.4058 13.9911 9.40471 16.0406 7.57249C17.8324 5.97112 20.2264 5.56494 22.4437 6.48251C26.013 7.96114 29.0669 8.07803 31.5245 6.82441C33.1253 6.00911 36.8942 5.15291 39.6877 7.76535"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M24 14.4354C25.3779 15.5809 27.3174 15.4435 28.4434 14.7305C29.8763 13.8217 32.5742 13.6405 33.9029 14.7656C34.8234 15.5458 37.0871 15.537 38.1523 14.748"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M37.3426 44.5624V34.2737C37.3426 33.9021 37.0856 33.6019 36.7686 33.6019H25.0016M31.6511 29.917V25.463C31.6511 24.6197 32.2936 23.9336 33.0818 23.9336H41.4264C42.2146 23.9336 42.8571 24.6197 42.8571 25.463V38.4447M12.4492 44.6572H46.0017"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path d="M4 44.6582H10.4842" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
